import { render, staticRenderFns } from "./PdfLinkItem.vue?vue&type=template&id=1bc632a4&scoped=true&"
import script from "./PdfLinkItem.vue?vue&type=script&lang=ts&"
export * from "./PdfLinkItem.vue?vue&type=script&lang=ts&"
import style0 from "./PdfLinkItem.vue?vue&type=style&index=0&id=1bc632a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc632a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCardTitle,VChip,VRow})
